import { render, staticRenderFns } from "./ViewTradesModal.vue?vue&type=template&id=e6bf9d4c&"
import script from "./ViewTradesModal.vue?vue&type=script&lang=js&"
export * from "./ViewTradesModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewTradesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports